import zhCN from './json/submit-tips.zh_CN.json';
import zhTW from './json/submit-tips.zh_TW.json';
import en from './json/submit-tips.en.json';
import ja from './json/submit-tips.ja.json';
import ko from './json/submit-tips.ko.json';
import ru from './json/submit-tips.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
